import { useQuery } from "@apollo/client";
import {
  FIND_ALL_LIBRARY_UPLIFTS,
  LIBRARY_ASSUMPTIONS_QUERY,
  LIBRARY_DISBURSEMENTS_QUERY,
  LIBRARY_EXCLUSIONS_QUERY,
} from "../../../graphql/query";
import { useEffect, useState } from "react";
import { FindAllLibraryUpliftsQuery, FindLibraryDisbursementsQuery } from "../../../gql/graphql";
import { LibraryUplift } from "@design-system";

// TODO JS: fix create new ordering

const LIBRARY_DISCOUNTS = [
  "Client requested a discount",
  "Volunteered without client request",
  "Acknowledge client spend level/repeat work",
  "Client providing testimonial/reference",
  "Concession for historical issues/concerns",
  "Willingness to discount to get job",
  "Number of direct competitors for this job",
  "Low cost competitors involved",
  "Relative strength of competition",
  "Strategic importance of the client/job to the firm",
  "Procurement involvement",
  "Client status",
  "New client origination source/referral",
];

// Function to group library uplifts by category
function groupBy<
  T extends {
    id: number;
    reason: string;
    group: string;
  }
>(objectArray: T[] = [], property: keyof T): Record<string, T[]> {
  return objectArray.reduce((acc: any, obj: T) => {
    const key = obj[property] ?? "Other";
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

export function useLibraryAssumptions(practiceAreaFilter?: number) {
  const { data: libraryAssumptionsData, loading } = useQuery(LIBRARY_ASSUMPTIONS_QUERY, {
    variables: {
      filter: {
        ...(practiceAreaFilter
          ? {
              organisationalUnits: {
                some: {
                  id: { equals: practiceAreaFilter },
                },
              },
            }
          : {
              organisationalUnits: {
                none: {},
              },
            }),
      },
    },
    fetchPolicy: "network-only",
  });

  return {
    libraryAssumptions: libraryAssumptionsData?.libraryAssumptions,
    loading,
  };
}

export function useLibraryExclusions(practiceAreaFilter?: number) {
  const { data: libraryExclusionsData, loading } = useQuery(LIBRARY_EXCLUSIONS_QUERY, {
    variables: {
      filter: {
        ...(practiceAreaFilter
          ? {
              organisationalUnits: {
                some: {
                  id: { equals: practiceAreaFilter },
                },
              },
            }
          : {
              organisationalUnits: {
                none: {},
              },
            }),
      },
    },
    fetchPolicy: "network-only",
  });

  return {
    libraryExclusions: libraryExclusionsData?.libraryExclusions,
    loading,
  };
}

export function useLibraryDisbursements() {
  const { data: libraryDisbursementsData, loading } = useQuery<FindLibraryDisbursementsQuery>(
    LIBRARY_DISBURSEMENTS_QUERY,
    {
      variables: {
        filter: {},
      },
    }
  );

  return {
    libraryDisbursements: libraryDisbursementsData?.libraryDisbursements,
    loading,
  };
}

export function useLibraryUplifts() {
  const { data: libraryUpliftsData, loading } =
    useQuery<FindAllLibraryUpliftsQuery>(FIND_ALL_LIBRARY_UPLIFTS);

  const [groupedUplifts, setGroupedUplifts] = useState<Record<string, LibraryUplift[]>>({});

  useEffect(() => {
    if (libraryUpliftsData?.findAllLibraryUplifts) {
      setGroupedUplifts(groupBy(libraryUpliftsData.findAllLibraryUplifts, "group"));
    }
  }, [libraryUpliftsData]);

  return {
    libraryUplifts: groupedUplifts,
    loading,
  };
}

export function useLibraryDiscounts() {
  const [libraryDiscounts, setLibraryDiscounts] = useState<string[]>(LIBRARY_DISCOUNTS);

  return {
    libraryDiscounts,
    loading: false,
  };
}